module.exports = "/_next/static/images/award-duotone-5769e723655b48c44c09b6063631c815.svg";